import React from 'react';

import { DisplayUserName } from '@adsk/alloy-provider';
import { Text } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import { useEntityData } from '../../hooks';
import { useTranslation } from '../../i18n';

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

interface MainEntityDisplayCellProps {
  mainEntityId: string;
  currentUserId: string;
  currentUserRoleId: string;
  currentUserCompanyId: string;
  totalEntities: string[];
  isMainEntityUser?: boolean;
  stacked?: boolean;
  size?: SIZES;
}

const MainEntityDisplay: React.FC<MainEntityDisplayCellProps> = ({
  mainEntityId,
  totalEntities,
  currentUserId,
  currentUserRoleId,
  currentUserCompanyId,
  stacked = false,
  size = SIZES.MEDIUM,
  isMainEntityUser = false,
}) => {
  const { t } = useTranslation();

  const sizeStyle =
    size === SIZES.SMALL
      ? theme.typography.bodySmall
      : theme.typography.bodyMedium;

  const currentUserStyle =
    totalEntities.includes(currentUserId) ||
    totalEntities.includes(currentUserRoleId) ||
    totalEntities.includes(currentUserCompanyId)
      ? { ...sizeStyle, backgroundColor: theme.colors.adskBlue100 }
      : sizeStyle;

  const mainEntity = useEntityData(mainEntityId);
  const { name, property } = mainEntity;

  const renderProperty = () => {
    if (!property) return null;
    return stacked ? (
      <>
        <br />
        <Text color="charcoal700" style={sizeStyle}>
          {property}
        </Text>
      </>
    ) : (
      <Text marginLeft="4px" style={sizeStyle}>
        ({property})
      </Text>
    );
  };

  const renderSubtext = () => {
    return stacked ? (
      <>
        <br />
        <Text style={sizeStyle}>
          {t('MORE_USERS', {
            count: totalEntities.length - 1,
          })}
        </Text>
      </>
    ) : (
      <Text style={sizeStyle}>
        {t('MORE_USERS', {
          count: totalEntities.length - 1,
        })}
      </Text>
    );
  };

  return (
    <>
      {isMainEntityUser ? (
        <Text style={currentUserStyle}>
          <DisplayUserName id={mainEntityId} />
        </Text>
      ) : (
        <Text style={currentUserStyle}>{name}</Text>
      )}
      {totalEntities.length >= 2 ? renderSubtext() : renderProperty()}
    </>
  );
};

MainEntityDisplay.displayName = 'SubmittalsMainEntityDisplay';

export default MainEntityDisplay;
